export default {
    TITLE:'Let\'s talk money…',
    SUBTITLE:'Source of funds',
    TOOLTIP:'Source of funds refers to the origin of money used for the new company’s current and future payments.<br></br>Source of wealth refers to how this person accrued their total wealth. '
}